export const supportedBrowsersRegex = /Edge?\/(13[7-9]|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(14\d|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(13[7-9]|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(18\.([2-9]|\d{2,})|(19|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(18[._]([2-9]|\d{2,})|(19|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)|Android.+Chrom(ium|e)\/(14[1-9]|1[5-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)/;
export const supportedBrowsers = [
"and_chr 141",
"chrome 141",
"chrome 140",
"chrome 139",
"chrome 138",
"chrome 137",
"edge 141",
"edge 140",
"edge 139",
"edge 138",
"edge 137",
"firefox 144",
"firefox 143",
"firefox 142",
"firefox 141",
"firefox 140",
"ios_saf 26.0",
"ios_saf 18.5-18.6",
"ios_saf 18.4",
"ios_saf 18.3",
"ios_saf 18.2",
"safari 26.0",
"safari 18.5-18.6",
"safari 18.4",
"safari 18.3",
"safari 18.2"
];
